"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlParts = exports.getCollector = exports.isPharmacy = exports.getRootDomain = exports.isValidUrl = void 0;
const isValidUrl = (urlString) => {
    try {
        return Boolean(new URL(urlString));
    }
    catch (e) {
        return null;
    }
};
exports.isValidUrl = isValidUrl;
// copy of isValidUrl to remove extra dependencies on myget
function getRootDomain(hostname) {
    const url = hostname || window.location.origin;
    if ((0, exports.isValidUrl)(url)) {
        const domain = new URL(url);
        const m = domain.hostname.match(/^(?:.*?\.)?([a-zA-Z0-9\-_]{3,}\.(?:\w{2,8}|\w{2,4}\.\w{2,4}))$/);
        if (m) {
            return m[1];
        }
    }
    return '';
}
exports.getRootDomain = getRootDomain;
function isPharmacy(origin) {
    return origin.split('.').some((part) => part === 'pharmacy');
}
exports.isPharmacy = isPharmacy;
function getCollector(origin, isProd) {
    const appId = getRootDomain();
    if (isPharmacy(origin)) {
        return isProd
            ? 'collector.pharmacy.healthcare.com'
            : 'collector.dev.pharmacy.healthcare.com';
    }
    if (isProd) {
        return `sp.${appId}`;
    }
    const matchQa = origin.match(/(^|\.)qa\./);
    if (matchQa) {
        return `spnp.qa.${appId}`;
    }
    const matchStg = origin.match(/(^|\.)stg\./);
    if (matchStg) {
        return `spnp.stg.${appId}`;
    }
    const matchLocal = origin.match(/(^|\.)local\./);
    if (matchLocal) {
        return `spnp.dev.${appId}`;
    }
    return `spnp.dev.${appId}`;
}
exports.getCollector = getCollector;
function getUrlParts(url) {
    const { hostname, pathname, search } = new URL(url);
    return {
        hostname,
        path: pathname,
        query: search.length > 0 ? search.substring(1) : search,
    };
}
exports.getUrlParts = getUrlParts;
//# sourceMappingURL=url.js.map